export function sumDeltas(numbers) {
    return numbers.reduce((sum, v, i, a) => {
        sum[i] = v + (sum[i - 1] ?? 0);
        return sum;
    }, []);
}

export function convertUnitTimeline(player) {
    const buildOrder = player.buildOrder;

    const timestamps = player.resources.timestamps;
    const villagerDeltas = Array(timestamps.length).fill(0);
    const traderDeltas = Array(timestamps.length).fill(0);
    const fishingShipDeltas = Array(timestamps.length).fill(0);
    const maliCattleDeltas = Array(timestamps.length).fill(0);
    const totalEcoDeltas = Array(timestamps.length).fill(0);
    const ecoDeltas = Array(timestamps.length).fill(0);
    let economyLost = 0;

    // Collect units create/destroy by type
    for (let item of buildOrder) {
        const spawned = [...item.finished, ...item.constructed];
        const destroyed = [...item.destroyed];

        if (item.unknown?.["14"]) spawned.push(...item.unknown["14"]);
        if (item.unknown?.["15"]) destroyed.push(...item.unknown["15"]);

        const type =
            /villager$/.test(item.icon) ? 'villager' :
                /(trader|trade_cart|trade_ship)$/.test(item.icon) ? 'trader' :
                    /fishing_boat$/.test(item.icon) ? 'fishing_ship' :
                        /units\/cattle$/.test(item.icon) ? 'mali_cattle' :
                            'other';

        if (type !== 'other') {

            // All the times that a unit got created, add +1 to the deltas
            for (const timestamp of spawned) {
                const i = timestamps.findIndex((interval) => interval > timestamp);
                if (i >= 0) {
                    if (type === 'mali_cattle') {
                        maliCattleDeltas[i] += 1;
                        totalEcoDeltas[i] += 1;
                        continue;
                    }
                    if (type === 'villager') villagerDeltas[i] += 1;
                    if (type === 'trader') traderDeltas[i] += 1;
                    if (type === 'fishing_ship') fishingShipDeltas[i] += 1;
                    ecoDeltas[i] += 1;
                    totalEcoDeltas[i] += 1;
                }
            }

            // All the times that a unit got descript, add -1 to the deltas, it'll get summed up later
            for (const timestamp of destroyed) {
                const i = timestamps.findIndex((interval) => interval > timestamp);
                if (i >= 0) {
                    if (type === 'mali_cattle') {
                        maliCattleDeltas[i] -= 1;
                        totalEcoDeltas[i] -= 1;
                        continue;
                    }
                    if (type === 'villager') villagerDeltas[i] -= 1;
                    if (type === 'trader') traderDeltas[i] -= 1;
                    if (type === 'fishing_ship') fishingShipDeltas[i] -= 1;
                    ecoDeltas[i] -= 1;
                    totalEcoDeltas[i] -= 1;
                    economyLost += 1;
                }
            }
        }
    }

    // Create timeline
    let villagerTimeline = sumDeltas(villagerDeltas);
    let traderTimeline = sumDeltas(traderDeltas);
    let fishingShipTimeline = sumDeltas(fishingShipDeltas);
    let ecoTimeline = sumDeltas(ecoDeltas);
    let totalEcoTimeline = sumDeltas(totalEcoDeltas);
    let cattleTimeline = sumDeltas(maliCattleDeltas);
    let villagerMax = Math.max(...villagerTimeline);
    let traderMax = Math.max(...traderTimeline);
    let fishingShipMax = Math.max(...fishingShipTimeline);
    let ecoMax = Math.max(...ecoTimeline);

    return {
        maxVillagers: villagerMax,
        maxTraders: traderMax,
        maxFishingShips: fishingShipMax,
        maxEconomyUnits: ecoMax,
        timelineVillagers: villagerTimeline,
        timelineEconomyUnits: ecoTimeline,
        timelineTotalEconomyUnits: totalEcoTimeline,
        timelineCattle: cattleTimeline,
        economyLost
    };
}